import { render, staticRenderFns } from "./AiPublishMiniappButton.vue?vue&type=template&id=0d1e04e8&scoped=true"
import script from "./AiPublishMiniappButton.vue?vue&type=script&lang=js"
export * from "./AiPublishMiniappButton.vue?vue&type=script&lang=js"
import style0 from "./AiPublishMiniappButton.vue?vue&type=style&index=0&id=0d1e04e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1e04e8",
  null
  
)

export default component.exports